import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Skeleton } from '@/components/ui/skeleton'
import { documentQuery } from '@/features/documents/api'
import { DocumentComposer } from '@/features/documents/composer/composer'

const searchSchema = z.object({
  kind: z.enum(['FE', 'TE', 'NC', 'ND', 'FEC']).default('FE'),
  /** Comprobante origen: se corrige (NC/ND) o se duplica. */
  from: z.string().optional(),
  /** Cliente que llega preseleccionado (desde su ficha). */
  customerId: z.string().optional(),
})

export const Route = createFileRoute('/_app/documents/new')({
  staticData: { crumb: 'Nuevo comprobante' },
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => ({ from: search.from }),
  loader: ({ context, deps }) =>
    deps.from ? context.queryClient.ensureQueryData(documentQuery(deps.from)) : null,
  pendingComponent: () => (
    <div className="mx-auto grid gap-6 px-8 py-8 xl:grid-cols-[1fr_380px]">
      <Skeleton className="h-[480px] rounded-xl" />
      <Skeleton className="h-[480px] rounded-xl" />
    </div>
  ),
  component: NewDocument,
})

function NewDocument() {
  const { kind, customerId } = Route.useSearch()
  const source = Route.useLoaderData()
  const isNote = kind === 'NC' || kind === 'ND'
  return (
    <DocumentComposer
      key={`${kind}-${source?.id ?? 'new'}-${customerId ?? ''}`}
      kind={kind}
      customerId={customerId}
      source={source}
      sourceMode={source ? (isNote ? 'note' : 'clone') : undefined}
    />
  )
}
